import { gql } from '@apollo/client';

export const GENERATE_TOKEN = `
  mutation GenerateAccessToken($refreshToken: String!) {
  generateAccessToken(refreshToken: $refreshToken) {
    token
  }
}
`;

export const LOGOUT = gql(`mutation Logout {
  logout {
    message
    status
  }
}`);

export const GENERATE_OTP =
  gql(`mutation GenerateOtp($countryCode: String!, $phoneNumber: String!) {
  generateOtp(countryCode: $countryCode, phoneNumber: $phoneNumber) {
    message
    status
  }
}`);

export const VERIFY_OTP =
  gql(`mutation VerifyOtp($countryCode: String!, $phoneNumber: String!, $otp: String!) {
  verifyOtp(countryCode: $countryCode, phoneNumber: $phoneNumber, otp: $otp) {
    accessToken
    refreshToken
  }
}`);

export const UPDATE_USER = gql(`mutation UpdateUser($data: UpdateUserInput!) {
  updateUser(data: $data) {
    _id
  }
}`);

export const READ_NOTIFICATION_BY_ID = gql(`mutation ReadOneNotification($id: ID!) {
  readOneNotification(_id: $id) {
    message
    status
  }
}`);

export const DELETE_ALL_NOTIFICATIONS = gql(`mutation DeleteManyNotification($filter: JSON!) {
  deleteManyNotification(filter: $filter) {
    _id
  }
}`)

export const UPDATE_DEVICE_TOKEN = gql(`mutation UpdateDeviceToken($data: UpdateDeviceTokenInput!) {
  updateDeviceToken(data: $data) {
    _id
  }
}`);
